import React from 'react'

import { getExpiredTime, incRetryInterval, restoreAuth, setRetryInterval } from 'services/auth'
import { getApolloClient } from 'api/apollo'

const refreshTokenProcess = () => {
  const timeLeft = getExpiredTime() || incRetryInterval()
  console.log('timeLeft=', timeLeft)
  if (timeLeft === null) return

  const timer = setTimeout(() => {
    console.log('end timeout')
    restoreAuth({
      client: getApolloClient({ setError: console.error }),
      onComplete: () => {
        console.log('onComplete')
        clearTimeout(timer)
        refreshTokenProcess()
        setRetryInterval()
      },
      onError: () => {
        console.log('onError')
        clearTimeout(timer)
        refreshTokenProcess()
      }
    })
  }, timeLeft > 2147483647 ? 2147483647 : timeLeft) // new Date(2147483647): Sun Jan 25 1970 21:31:23 GMT+0100 (Central European Standard Time)

  return timer
}

function RefreshToken() {
  React.useEffect(() => {
    setRetryInterval()
    const timer = refreshTokenProcess()
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
      setRetryInterval()
    }
  }, [])

  return null
}

export default RefreshToken
